var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import Model from './Model';
import Color from 'color';
var toUnixMs = function (date) { return date && !isNaN(date.getTime()) ? date.getTime() : null; };
/**
 *
 */
var ManualAssetModel = /** @class */ (function (_super) {
    __extends(ManualAssetModel, _super);
    /**
     *
     * @param data
     */
    function ManualAssetModel(data) {
        if (data === void 0) { data = null; }
        var _this = _super.call(this, data) || this;
        _this.emissionClass = null;
        _this.nominalPower = null;
        _this.fuelType = null;
        _this.cumulativeOperatingHoursValue = {
            timestamp: null,
            value: 0
        };
        _this.fuelUsedInLiters = {
            timestamp: null,
            value: 0
        };
        _this.location = {
            latitude: 0,
            longitude: 0,
            altitudeInMeters: 0,
            timestamp: null
        };
        return _this;
    }
    /**
     *
     * @param assetModel
     */
    ManualAssetModel.prototype.updateFromAssetModel = function (assetModel) {
        this.id = assetModel.getMetricsDbId();
        this.serialNumber = assetModel.properties.serialNumber;
        this.equipmentId = assetModel.properties.equipmentId;
        this.make = assetModel.properties.make;
        this.model = assetModel.properties.model;
        this.alias = assetModel.properties.alias;
        this.emissionClass = assetModel.emissionClass;
        this.nominalPower = assetModel.nominalPower;
        this.fuelType = assetModel.fuelType;
        this.iconName = assetModel.properties.iconName;
        this.iconColor = new Color(assetModel.properties.iconColorRgba);
        this.cumulativeOperatingHoursValue.value = assetModel.cumulativeOperatingHoursDurationInHours;
        this.cumulativeOperatingHoursValue.timestamp = toUnixMs(assetModel.cumulativeOperatingHoursDateTime);
        this.fuelUsedInLiters.value = assetModel.fuelUsedInLiters;
        this.fuelUsedInLiters.timestamp = toUnixMs(assetModel.fuelUsedDateTime);
        this.location.latitude = assetModel.geometry.coordinates[1];
        this.location.longitude = assetModel.geometry.coordinates[0];
        this.location.timestamp = toUnixMs(assetModel.locationDateTime);
    };
    /**
     *
     * @return {UpdateManualAssetRequest}
     */
    ManualAssetModel.prototype.toUpdateRequest = function () {
        return {
            alias: this.alias,
            equipmentId: this.equipmentId,
            make: this.make,
            model: this.model,
            emissionClass: this.emissionClass,
            nominalPower: this.nominalPower,
            fuelType: this.fuelType
        };
    };
    __decorate([
        observable
    ], ManualAssetModel.prototype, "id", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "equipmentId", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "serialNumber", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "make", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "model", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "alias", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "emissionClass", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "nominalPower", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "fuelType", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "iconName", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "iconColor", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "cumulativeOperatingHoursValue", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "fuelUsedInLiters", void 0);
    __decorate([
        observable
    ], ManualAssetModel.prototype, "location", void 0);
    return ManualAssetModel;
}(Model));
export default ManualAssetModel;
